import $ from 'jquery';
import _ from 'underscore';
import Numeral from 'numeral';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Router from 'root/router';
import Constants from 'root/constants';
import Modals from 'root/modals';
import View from 'view/base';

import View_Feedback_Group_Action from 'view/feedback_group_action';
import View_Feedback_Board from 'view/feedback_board';
import View_Feedback_Preview from 'view/feedback_preview';
import View_Feedback_Search from 'view/feedback_search';
import View_Feedback_Filter from 'view/feedback_filter';
import View_Feedback_Inbox from 'view/feedback_inbox/index';

import jui from 'root/lib/jquery-ui.min';

export default View.extend({
    tagName: 'section',
    className: 'fullscroll', // with fullscroll-action-bar

    page: 1,
    num_per_page: 30,

    search_options: {},

    search_in_progress: false,

    all_boards_loaded: false,

    views: {
        preview: {},
        feedback_inbox: {},
        feedback_search: {},
        feedback_filter: {},
        feedback_group_action: {},
        boards: {}
    },

    feedback_view: 'board', // grid, inbox, board
    feedback_order: 'desc', // asc, desc
    feedback_order_type: 'create', // create, update
    feedback_groupby: '', // status, priority, rating, assignee

    show_screenshot: true,

    // search filters
    filters: {
        workflow       : [],
        feedback_type  : [],
        assignee       : [],
        priority       : [],
        category       : [],
        segment        : [],
        user_property  : null,
        include_merged : false,
    },

    events: {
        'submit .quick-search'                 : 'quickSearch',
        'click .quick-search-clear'            : 'clearQuickSearch',
        'click .clear-search'                  : 'clearSearch',
        'click .feedback-filters-clear'        : 'clearFilters',
        'click .advanced-search-toggle'        : 'toggleAdvancedSearch',
        'click .select-all input'              : 'selectAll',
        'click .edit-status'                   : 'editWorkflow',
        'click .dropdown-view-type li'         : 'changeFeedbackView',
        'click .sort-by-type'                  : 'changeFeedbackSortType',
        'click .sort-by-order'                 : 'changeFeedbackSortOrder',
        'click .show-screenshot'               : 'changeViewSettings',
        'click .group-by'                      : 'changeFeedbackGroupBy',
        'click .clear-selection'               : 'clearSelection',
        'click .feedback-upload-design'        : 'selectDesign',
        'click .feedback-upload-pdf'           : 'selectPdf',
        'click .feedback-upload-video'         : 'selectVideo',
        'click .file-type-design'              : 'selectDesign',
        'click .file-type-pdf'                 : 'selectPdf',
        'click .file-type-video'               : 'selectVideo',
        'click .feedback-scrape a'             : 'scrapeWebsite',
        'click .upload-design'                 : 'onUploadDesign',
        'change .image-uploader'               : 'uploadImage',
        'change .pdf-uploader'                 : 'uploadPdf',
        'change .video-uploader'               : 'uploadVideo',
        'click .install-widget'                : 'installWidget',
        'click .feedback-demo'                 : 'onOpenDemo',
        'click .video-explainer'               : 'onPlayVideo',
        'mousedown .kanban-indicator-widget'   : 'onKanbanDragStart',
        'mouseup .kanban-indicator-widget'     : 'onKanbanDragStop',
        'mousemove .kanban-indicator-widget'   : 'onKanbanDragMove',
        'mouseleave .kanban-indicator-widget'  : 'onKanbanDragStop'
    },

    dom_handlers: {
        onUploadDesign: function(e) {
            this.$el.find('.feedback-upload-dropdown').show();
        },

        onKanbanDragStart: function(e) {
            this.kanban_drag_pos_start = e.pageX;
            this.kanban_scroll_start   = this.$el.find('.feedback-board-container > div').scrollLeft();
        },

        onKanbanDragStop: function(e) {
            if (this.kanban_drag_pos_start === false) {
                return;
            }

            this.kanban_drag_pos_start = false;
            this.kanban_scroll_start   = false;

            var css_left    = parseFloat(this.$el.find('.kanban-indicator-widget').css('left').replace('px', ''));
            var transform_x = this.$el.find('.kanban-indicator-widget').data('drag_x');

            this.$el.find('.kanban-indicator-widget').css({
                'left'      : css_left + transform_x,
                'transform' : ''
            });
        },

        onKanbanDragMove: function(e) {
            if (this.kanban_drag_pos_start) {
                var scroller_width   = this.$el.find('.kanban-column-indicator .scroller').width();
                var widget           = this.$el.find('.kanban-indicator-widget');
                var scroll_container = this.$el.find('.feedback-board-container > div');

                var movement = (e.pageX - this.kanban_drag_pos_start);

                var min = parseFloat(widget.css('left').replace('px', ''));
                var max = scroller_width - min - widget.width();

                if (movement > max) {
                    movement = max;
                } else if (movement < min * -1) {
                    movement = min * -1;
                }

                widget
                    .css('transform', 'translateX(' + movement + 'px)')
                    .data('drag_x', movement);

                scroll_container.scrollLeft(this.kanban_scroll_start + movement / scroller_width * scroll_container.get(0).scrollWidth);
            }
        },

        installWidget: function() {
            Modals.getWidgetCode();
        },

        onOpenDemo: function() {
            Modals.openDemo(() => {
                // track onboarding
                Cache.app.trackProjectOnboarding('try_widget', 1);

                // refresh the page
                this.search();
            });
        },

        onPlayVideo: function() {
            Modals.previewVideo(this.$el.find('video source').attr('src'), 'autoplay controls');
        },

        uploadImage: function(e) {
            var files = e.target.files || e.dataTransfer.files;

            if (files.length > 10) {
                UI.error('Please upload up to 10 files at a time.');
                return;
            }

            this.$el.find('input[type="file"]').remove();

            if (files.length === 1) {
                Modals.uploadFiles(files, 15, true, 'feedback/uploadImage', 'View my design', (feedback_ids) => {
                    this.openFeedback(feedback_ids[0]);
                }, {
                    workflow_id: Cache.workflow.at(0).id
                }, () => {
                    this.search();
                });
            } else {
                Modals.uploadFiles(files, 15, true, 'feedback/uploadImage', 'View my designs', (feedback_ids) => {
                    this.search();
                }, {
                    workflow_id: Cache.workflow.at(0).id
                });
            }
        },

        uploadPdf: function(e) {
            var files = e.target.files || e.dataTransfer.files;

            if (files.length > 10) {
                UI.error('Please upload up to 10 files at a time.');
                return;
            }

            this.$el.find('input[type="file"]').remove();

            if (files.length === 1) {
                Modals.uploadFiles(files, 15, false, 'feedback/uploadPdf', 'View my PDF file', (feedback_ids) => {
                    this.openFeedback(feedback_ids[0]);
                }, {
                    workflow_id: Cache.workflow.at(0).id
                }, () => {
                    this.search();
                });
            } else {
                Modals.uploadFiles(files, 15, false, 'feedback/uploadPdf', 'View my PDF files', () => {
                    this.search();
                }, {
                    workflow_id: Cache.workflow.at(0).id
                });
            }
        },

        uploadVideo: function(e) {
            var files = e.target.files || e.dataTransfer.files;

            if (files.length > 5) {
                UI.error('Please upload up to 5 files at a time.');
                return;
            }

            this.$el.find('input[type="file"]').remove();

            if (files.length === 1) {
                Modals.uploadVideo(e.target.files, 50, {workflow_id: Cache.workflow.at(0).id},
                (response) => {
                    this.openFeedback(response[0]['feedback_id']);
                },
                () => {
                    this.search();
                });
            } else {
                Modals.uploadVideo(e.target.files, 50, {workflow_id: Cache.workflow.at(0).id},
                () => {
                    this.search();
                });
            }
        },

        selectDesign: function(e) {
            e.preventDefault();

            $('<input>')
                .attr('type', 'file')
                .attr('accept', 'image/png, image/jpeg, image/gif')
                .attr('multiple', 'true')
                .addClass('image-uploader hidden')
                .appendTo(this.$el).click();
        },

        selectPdf: function(e) {
            e.preventDefault();

            $('<input>')
                .attr('type', 'file')
                .attr('accept', 'application/pdf')
                .attr('multiple', 'true')
                .addClass('pdf-uploader hidden')
                .appendTo(this.$el).click();
        },

        selectVideo: function(e) {
            e.preventDefault();

            $('<input>')
                .attr('type', 'file')
                .attr('multiple', 'true')
                .attr('accept', 'video/mp4, video/quicktime')
                .addClass('video-uploader hidden')
                .appendTo(this.$el).click();
        },

        scrapeWebsite: function(e) {
            e.preventDefault();

            Modals.scrapeWebsite(Cache.workflow.at(0).id, (feedback_ids) => {
                if (feedback_ids.length === 1) {
                    this.openFeedback(feedback_ids[0]);
                }
            }, () => {
                this.search();
            });
        },

        changeFeedbackView: function(e) {
            var type = $(e.currentTarget).data('val');

            Router.removeQueryString(['feedback_id', 'workflow', 'order', 'groupby'], {trigger: false});

            Router.addQueryString('t', type, {trigger: false});

            UI.buildPage('feedback', {
                is_design: this.is_design
            });

            Cache.app.addUserSetting('feedback_view_type', type, true);
        },

        changeFeedbackSortType: function(e) {
            this.feedback_order_type = $(e.currentTarget).data('val');

            Cache.app.addUserSetting('feedback_order', this.feedback_order_type + ':' + this.feedback_order, true);
            Router.addQueryString('order', this.feedback_order_type + ':' + this.feedback_order);

            this.$el.find('.feedback-preview-container').attr('data-sort', this.feedback_order_type);
            this.$el.find('.feedback-board-container').attr('data-sort', this.feedback_order_type);

            this.renderSortDropdown();

            this.page = 1;
            this.search();
        },

        changeFeedbackSortOrder: function(e) {
            this.feedback_order = $(e.currentTarget).data('val');

            Cache.app.addUserSetting('feedback_order', this.feedback_order_type + ':' + this.feedback_order, true);
            Router.addQueryString('order', this.feedback_order_type + ':' + this.feedback_order);

            this.$el.find('.feedback-preview-container').attr('data-sort', this.feedback_order_type);
            this.$el.find('.feedback-board-container').attr('data-sort', this.feedback_order_type);

            this.renderSortDropdown();

            this.page = 1;
            this.search();
        },

        changeViewSettings: function(e) {
            this.show_screenshot = !this.show_screenshot;

            Cache.app.addUserSetting('show_screenshot', this.show_screenshot, true);

            this.renderSortDropdown();

            // feedback preview views listen to this event
            Cache.app.dispatcher.trigger('feedback:toggle:screenshot');
        },

        changeFeedbackGroupBy: function(e) {
            this.feedback_groupby = $(e.currentTarget).data('val');

            Router.addQueryString('groupby', this.feedback_groupby);
            Router.removeQueryString(['priority', 'assignee'], {trigger: false});
            Cache.app.addUserSetting('feedback_groupby', this.feedback_groupby, true);

            UI.buildPage('feedback', {
                is_design: this.is_design
            });
        },

        toggleAdvancedSearch: function() {
            this.$el.find('.advanced-search-filters').toggle();
            this.views.feedback_search.trigger('open');
        },

        documentKeydown: function(e) {
            if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT') {
                return;
            }

            if ($(e.target).prop('contenteditable') == 'true') {
                return;
            }

            if (this.getViewType() !== 'inbox') {
                return;
            }

            switch (e.which) {
                case 38:
                    e.preventDefault();
                    var feedback_element = this.$el.find('.feedback-preview-open').prev('.feedback-preview');

                    if (feedback_element.length) {
                        feedback_element.trigger('click');
                        this.scrollToFeedback(feedback_element);
                    }
                    break;
                case 40:
                    e.preventDefault();
                    var feedback_element = this.$el.find('.feedback-preview-open').next('.feedback-preview');

                    if (feedback_element.length) {
                        feedback_element.trigger('click');
                        this.scrollToFeedback(feedback_element);
                    }
                    break;
            }
        },

        documentClick: function(e) {
            if ($(e.target).hasClass('quick-search') || $(e.target).parents('.quick-search').length) {
                return;
            }

            if ($(e.target).hasClass('advanced-search-toggle') || $(e.target).parents('.advanced-search-toggle').length) {
                return;
            }

            if ($(e.target).hasClass('advanced-search-filters') || $(e.target).parents('.advanced-search-filters').length) {
                return;
            }

            this.$el.find('.advanced-search-filters').hide();

            if (!$(e.target).hasClass('upload-design') && !$(e.target).parents('.upload-design').length) {
                this.$el.find('.feedback-upload-dropdown').hide();
            }
        },

        windowResize: function(e) {
            if (this.getViewType() === 'board') {
                var indicator       = this.$el.find('.kanban-column-indicator');
                var board_container = this.$el.find('.feedback-board-container > div');

                var visible_percentage = this.$el.innerWidth() / (board_container.get(0).scrollWidth) * 100;

                if (visible_percentage < 100) {
                    indicator.show();
                    indicator.find('.kanban-indicator-widget').css({
                        width : visible_percentage + '%'
                    });
                } else {
                    indicator.hide();
                }
            }
        },

        quickSearch: function(e) {
            e.preventDefault();

            var search_val = this.$el.find('.quick-search input').val().trim();

            this.$el.find('.quick-search-clear').toggle(search_val.length > 0);

            if (search_val.length) {
                Router.addQueryString('search', search_val, {trigger: false});
            } else {
                Router.removeQueryString('search', {trigger: false});
            }

            this.page = 1;
            this.search();
        },

        clearQuickSearch: function() {
            this.$el.find('.quick-search input').val('');
            this.$el.find('.quick-search').submit();
        },

        clearSearch: function(e) {
            e.preventDefault();

            this.$el.find('.quick-search input').val('');
            this.$el.find('.quick-search-clear').hide();

            this.filters = {
                workflow       : [],
                feedback_type  : [],
                assignee       : [],
                priority       : [],
                category       : [],
                segment        : [],
                user_property  : null,
                include_merged : false
            };

            Cache.app.deleteUserSetting('feedback_workflow',       true);
            Cache.app.deleteUserSetting('feedback_type',           true);
            Cache.app.deleteUserSetting('feedback_assignee',       true);
            Cache.app.deleteUserSetting('feedback_priority',       true);
            Cache.app.deleteUserSetting('feedback_category',       true);
            Cache.app.deleteUserSetting('feedback_include_merged', true);

            this.views.feedback_filter.clear();
            this.views.feedback_search.clearSearch(this.feedback_order_type, this.feedback_order);

            this.renderActiveSearchOptions({});
        },

        clearFilters: function(e) {
            var search_value = this.$el.find('.quick-search input').val().trim();

            Cache.app.deleteUserSetting('feedback_workflow',       true);
            Cache.app.deleteUserSetting('feedback_type',           true);
            Cache.app.deleteUserSetting('feedback_assignee',       true);
            Cache.app.deleteUserSetting('feedback_priority',       true);
            Cache.app.deleteUserSetting('feedback_category',       true);
            Cache.app.deleteUserSetting('feedback_segment',        true);
            Cache.app.deleteUserSetting('feedback_user_property',  true);

            this.views.feedback_filter.clear();
            this.views.feedback_search.clearSearch(this.feedback_order_type, this.feedback_order, search_value);

            this.renderActiveSearchOptions({});
        },

        selectAll: function(e) {
            var is_select_all = $(e.currentTarget).prop('checked');

            this.$el.find('.feedback-preview .id input:checkbox').not(':disabled').prop('checked', !is_select_all).click();
        },

        clearSelection: function(e) {
            e.preventDefault();

            this.$el.find('.feedback-preview').find('.id input').each(function() {
                if ($(this).prop('checked')) {
                    $(this).click();
                }
            });
        },

        onBoardScroll: function(e) {
            if (this.kanban_drag_pos_start) {
                return;
            }

            var container    = this.$el.find('.feedback-board-container');
            var scroll_left  = container.children('div').scrollLeft();
            var scroll_width = container.children('div').get(0).scrollWidth;

            this.$el.find('.kanban-indicator-widget').css({
                left: scroll_left / scroll_width * this.$el.find('.kanban-column-indicator .scroller').width()
            });
        },

        onScrollFeedback: function(e) {
            if (this.search_in_progress) {
                return;
            }

            clearTimeout(this.feedback_scroll_load_timeout);
            this.feedback_scroll_load_timeout = setTimeout(() => {
                var scroll_container = $(e.currentTarget);
                var scroll_buffer = 200;

                if (scroll_container.get(0).scrollHeight - (scroll_container.scrollTop() + scroll_container.height()) <= scroll_buffer) {
                    this.loadMore();
                }
            }, 100);
        }
    },

    event_handlers: {
        // remove a model from collection
        onRemove: function(model) {
            if (this.views.preview['_' + model.id]) {
                this.views.preview['_' + model.id].remove();
                delete this.views.preview['_' + model.id];

                Cache.feedback.search_count--;
            }

            if (this.getViewType() === 'inbox') {
                if (this.views.feedback_inbox instanceof View_Feedback_Inbox &&
                    this.views.feedback_inbox.model.id === model.id) {

                    this.views.feedback_inbox.remove();
                }
            }

            // fire one update call only when deleting multiple feedback at once
            clearTimeout(this.workflow_count_timeout);
            this.workflow_count_timeout = setTimeout(() => {
                this.event_handlers.onFeedbackSelect.call(this);

                if (Cache.feedback.search_count > Cache.feedback.length) {
                    // there is more to load
                    if (Cache.feedback.length <= this.num_per_page - 5) {
                        // reload when 5 more more are deleted
                        this.search();
                    } else {
                        this.renderTotalSelected();
                    }
                } else if (Cache.feedback.length === 0) {
                    this.search();
                }
            });
        },

        onWorkflowRemove: function(workflow_model) {
            // on logout
            if (!Cache.workflow.length) {
                return;
            }

            if (this.filters.workflow.length && this.filters.workflow.indexOf(workflow_model.id)) {
                this.filters.workflow.splice(this.filters.workflow.indexOf(workflow_model.id), 1);
                this.views.feedback_filter.update({workflow: this.filters.workflow});
                this.search();
            }

            if (this.getViewType() === 'board' && this.feedback_groupby === 'status') {
                var view = this.views.boards['_' + workflow_model.id];

                if (view) {
                    view.remove();
                    delete this.views.boards['_' + workflow_model.id];

                    this.$el.find('.kanban-column-indicator .column').eq(0).remove();
                    $(window).trigger('resize.feedback');
                }
            }
        },

        // when workflow order is changed
        onWorkflowSort: function(workflow_model) {
            if (this.getViewType() === 'board') {
                if (this.feedback_groupby === 'status') {
                    this.$el.find('.kanban-column-indicator .column').remove();
                    Cache.workflow.where({project_id: Cache.default_project_id}).forEach((model, index) =>  {
                        var view = this.views.boards['_' + model.id];

                        if (!view) {
                            view = this.createBoardView(model, index);
                            view.render();
                        }

                        view.$el.appendTo(this.$el.find('.feedback-board-container > div'));

                        this.$el.find('.kanban-column-indicator').append($('<div>').addClass('column'));
                    });

                    $(window).trigger('resize.feedback');
                }
            }

            this.views.feedback_filter.update();
        },

        onReset: function() {
            // reset select all
            this.$el.find('.select-all input:checkbox').prop('checked', false);

            // destroy
            this.destroyPreviewView();

            if (this.views.feedback_inbox instanceof View_Feedback_Inbox) {
                this.views.feedback_inbox.remove();
            }

            // reset scroll
            this.getScrollContainer().scrollTop(0);

            // re-display
            this.page = Math.max(1, this.page);
            this.page = Math.min(this.getPageTotal(), this.page);

            this.$el.find('.feedback-no-result').hide();

            if (Cache.feedback.length) {
                Cache.feedback.each((model, index) => {
                    this.createPreviewView(model, true);
                });
            }

            this.event_handlers.onFeedbackSelect.call(this);
        },

        onAdd: function(model) {
            this.page = Math.max(1, this.page);
            this.page = Math.min(this.getPageTotal(), this.page);

            this.createPreviewView(model, true);
        },

        onFilterChange: function(filters) {
            var is_workflow_changed = _.difference(this.filters.workflow, filters.workflow).length > 0 || _.difference(filters.workflow, this.filters.workflow).length > 0;
            var is_assignee_changed = _.difference(this.filters.assignee, filters.assignee).length > 0 || _.difference(filters.assignee, this.filters.assignee).length > 0;
            var is_priority_changed = _.difference(this.filters.priority, filters.priority).length > 0 || _.difference(filters.priority, this.filters.priority).length > 0;

            this.filters = {
                workflow       : [...filters.workflow],
                feedback_type  : [...filters.feedback_type],
                assignee       : [...filters.assignee],
                priority       : [...filters.priority],
                category       : [...filters.category],
                segment        : [...filters.segment],
                user_property  : filters.user_property ? {...filters.user_property} : null,
                include_merged : filters.include_merged
            };

            var view_type = this.getViewType();

            // add query params
            var query_params = [
                {
                    name : 'workflow',
                    val  : this.filters.workflow.length ? this.filters.workflow.join(',') : ''
                },
                {
                    name : 'type',
                    val  : this.filters.feedback_type.length ? this.filters.feedback_type.join(',') : ''
                },
                {
                    name : 'assignee',
                    val  : this.filters.assignee.length ? this.filters.assignee.join(',') : ''
                },
                {
                    name : 'priority',
                    val  : this.filters.priority.length ? this.filters.priority.join(',') : ''
                },
                {
                    name : 'category',
                    val  : this.filters.category.length ? this.filters.category.join(',') : ''
                },
                {
                    name : 'segment',
                    val  : this.filters.segment.length ? this.filters.segment.join(',') : ''
                },
                {
                    name : 'user_property',
                    val  : this.filters.user_property ? JSON.stringify(this.filters.user_property) : ''
                },
                {
                    name : 'include_merged',
                    val  : this.filters.include_merged ? 1 : 0
                }
            ];

            var query_string_add    = {};
            var query_string_remove = [];

            query_params.forEach((query_param) => {
                if (query_param.val) {
                    query_string_add[query_param.name] = query_param.val;
                    Cache.app.addUserSetting('feedback_' + query_param.name, query_param.val, true);
                } else {
                    query_string_remove.push(query_param.name);
                    Cache.app.deleteUserSetting('feedback_' + query_param.name, true);
                }
            });

            Router.addMultipleQueryString(query_string_add, {trigger: false});
            Router.removeQueryString(query_string_remove, {trigger: false});

            if (view_type === 'board' && (
                (this.feedback_groupby === 'status'   && is_workflow_changed) ||
                (this.feedback_groupby === 'assignee' && is_assignee_changed) ||
                (this.feedback_groupby === 'priority' && is_priority_changed)
            )) {
                // rebuild page
                UI.buildPage('feedback', {
                    is_design: this.is_design
                });
            } else {
                this.page = 1;
                this.search();
            }
        },

        onSearchReset: function() {
            this.$el.find('.quick-search input').val('');
        },

        onSearchStart: function(search_data) {
            this.search_in_progress = true;

            if (this.getViewType() === 'board') {
                Cache.feedback.remove(Cache.feedback.models);
                Cache.feedback_comment.remove(Cache.feedback_comment.models);
                Cache.feedback_screenshot.remove(Cache.feedback_screenshot.models);
                Cache.feedback_approver.remove(Cache.feedback_approver.models);

                _.each(this.views.boards, (view) => {
                    view.load(_.extend({}, search_data, {
                        sort_type  : this.feedback_order_type,
                        sort_order : this.feedback_order
                    }), true);
                });
            }
        },

        onSearchComplete: function() {
            this.renderTotalSelected();

            this.$el.find('.feedback-no-result').toggle(Cache.feedback.length === 0);
            this.$el.find('.region-pagination').toggle(Cache.feedback.length > 0);
            this.toggleEmptyState();

            this.search_in_progress = false;

            if (Cache.feedback.length >= Cache.feedback.search_count) {
                this.toggleLoadMore(true, true);
            } else {
                this.toggleLoadMore(false, false);
            }
        },

        onSearchSubmit: function(search_options) {
            this.$el.find('.advanced-search-filters').hide();

            this.page = 1;
            this.search();
        },

        onFeedbackSelect: function() {
            var num_total = Cache.feedback.where({primary_feedback_id: 0}).length;
            var num_selected = Cache.feedback.where({selected: true}).length;

            if (!Cache.app.isClient()) {
                this.$el.find('.feedback-action-bar > div').toggleClass('flip', num_selected ? true : false);
                this.$el.find('.item-counter').find('.num').text(num_selected + (this.is_design ? ' design' + (num_selected === 1 ? '' : 's') : ' feedback'));
            }

            this.$el.find('.feedback-preview-container').toggleClass('has-selection', num_selected ? true : false);

            if (this.getViewType() === 'inbox') {
                if (num_selected >= num_total) {
                    this.$el.find('.select-all input:checkbox').prop('checked', true);
                } else {
                    this.$el.find('.select-all input:checkbox').prop('checked', false);
                }
            }
        },

        onFeedbackMerge: function(model) {
            if (!this.filters.include_merged && model.isMergedFeedback()) {
                Cache.feedback.remove(model);
            }
        },

        onBoardViewSearchComplete: function(data) {
            var total_loaded = 0;
            var board_size = _.size(this.views.boards);

            _.each(this.views.boards, (view) => {
                if (view.is_loaded) {
                    total_loaded++;
                }
            });

            // when all the boards are loaded for the first time
            if (total_loaded === board_size && !this.all_boards_loaded) {
                this.openFeedbackFromURL();
            }

            this.all_boards_loaded = total_loaded === board_size;
        }
    },

    // wait for search() to finish then open feedback
    openFeedback: function(feedback_id) {
        var feedback_model = Cache.feedback.get(feedback_id);

        if (feedback_model) {
            Modals.openFeedback(feedback_id);
        } else {
            this.open_timeout = setTimeout(() => {
                this.openFeedback(feedback_id);
            }, 100);
        }
    },

    // inbox view only
    scrollToFeedback: function(feedback_el) {
        var scroll_top = feedback_el.offset().top - (this.$el.find('.region-feedback-preview').offset().top - this.$el.find('.region-feedback-preview').scrollTop());
        var is_visible = true;

        if (feedback_el.offset().top + feedback_el.height() > this.$el.find('.region-feedback-preview').offset().top + this.$el.find('.region-feedback-preview').height()) {
            is_visible = false;
        } else if (this.$el.find('.region-feedback-preview').scrollTop() > scroll_top) {
            is_visible = false;
        }

        if (!is_visible) {
            this.$el.find('.region-feedback-preview').scrollTop(scroll_top);
        }
    },

    toggleLoadingMask: function(display) {
        if (this.getViewType() === 'board') {
            return;
        }

        if (this.getViewType() === 'inbox') {
            this.$el.find('.region-feedback-preview').toggleClass('loader', display);
        } else {
            this.$el.find('.region-feedback-preview').toggleClass('loading', display);

            this.$el.find('.feedback-loading-status').toggle(display);
        }
    },

    toggleLoadMore: function(display, no_more) {
        if (this.getViewType() === 'board') {
            return;
        }

        // do not display "All feedback loaded" where there is only one page of feedback
        if (this.page === 1 && no_more) {
            display = false;
            no_more = false;
        }

        this.$el.find('.region-feedback-preview')
            .toggleClass('loading-more', display)
            .toggleClass('loading-more-end', no_more);
    },

    getScrollContainer: function() {
        return this.getViewType() === 'inbox' ? this.$el.find('.region-feedback-preview') : this.$el.find('.fullscroll-body');
    },

    getPageTotal: function() {
        return Math.floor(Cache.feedback.search_count / this.num_per_page) + (Cache.feedback.search_count % this.num_per_page === 0 ? 0 : 1);
    },

    initialize: function(options) {
        this.is_design = !!options.is_design;

        // UI settings: order by, group by, view type
        this.initSettings();

        // Feedback filters
        this.initFilters();

        // Create Views
        this.views.feedback_search = new View_Feedback_Search({
            page       : this.page,
            sort_type  : this.feedback_order_type,
            sort_order : this.feedback_order,
            limit      : this.num_per_page,
            is_design  : this.is_design,
            view_type  : this.getViewType(),
            groupby    : this.feedback_groupby
        });

        this.views.feedback_filter = new View_Feedback_Filter({
            is_design      : this.is_design,
            workflow       : [...this.filters.workflow],
            feedback_type  : [...this.filters.feedback_type],
            assignee       : [...this.filters.assignee],
            priority       : [...this.filters.priority],
            category       : [...this.filters.category],
            segment        : [...this.filters.segment],
            user_property  : this.filters.user_property ? {...this.filters.user_property} : null,
            include_merged : this.filters.include_merged
        });

        this.views.feedback_group_action = new View_Feedback_Group_Action({
            is_design: this.is_design,
            view_type: this.getViewType()
        });

        if (this.getViewType() === 'board') {
            switch (this.feedback_groupby) {
                case 'status':
                    if (this.filters.workflow.length) {
                        const filtered_workflow = Cache.workflow.filter((workflow_model) =>
                            this.filters.workflow.includes(workflow_model.get('id'))
                        );

                        filtered_workflow.forEach((workflow_model, index) => {
                            this.createBoardView(workflow_model, index);
                        });
                    } else {
                        // All
                        Cache.workflow.where({project_id: Cache.default_project_id}).forEach((workflow_model, index) => {
                            this.createBoardView(workflow_model, index);
                        });
                    }

                    break;
                case 'priority':
                    if (this.filters.priority.length) {
                        this.filters.priority.forEach((priority) => {
                            this.createBoardView(null, null, priority);
                        });
                    } else {
                        ['urgent', 'high', 'neutral', 'low'].forEach((priority) => {
                            this.createBoardView(null, null, priority);
                        });
                    }

                    break;
                case 'assignee':
                    if (this.filters.assignee.length) {
                        this.filters.assignee.forEach((assignee_id) => {
                            this.createBoardView(null, null, null, assignee_id);
                        });
                    } else {
                        this.createBoardView(null, null, null, 0);
                        _.each(Cache.app.getUsersByProject(Cache.default_project_id, [Constants.ADMIN, Constants.ASSIGNEE]), (user) => {
                            this.createBoardView(null, null, null, user.id);
                        });
                    }

                    break;
            }
        }

        this.listenTo(this.views.feedback_search, 'search_submit',   this.event_handlers.onSearchSubmit);
        this.listenTo(this.views.feedback_search, 'search_start',    this.event_handlers.onSearchStart);
        this.listenTo(this.views.feedback_search, 'search_complete', this.event_handlers.onSearchComplete);
        this.listenTo(this.views.feedback_search, 'search_reset',    this.event_handlers.onSearchReset);

        this.listenTo(this.views.feedback_filter, 'filter::change',  this.event_handlers.onFilterChange);

        this.listenTo(Cache.workflow, 'remove', this.event_handlers.onWorkflowRemove);
        this.listenTo(Cache.workflow, 'sort',   this.event_handlers.onWorkflowSort);

        if (this.getViewType() !== 'board') {
            this.listenTo(Cache.feedback, 'remove', this.event_handlers.onRemove);
            this.listenTo(Cache.feedback, 'reset',  this.event_handlers.onReset);
            this.listenTo(Cache.feedback, 'add',    this.event_handlers.onAdd);
        }

        this.listenTo(Cache.feedback, 'change:selected', this.event_handlers.onFeedbackSelect);
        this.listenTo(Cache.feedback, 'change:primary_feedback_id', this.event_handlers.onFeedbackMerge.bind(this));

        Cache.app.dispatcher.on('Feedback::upload', () => {
            this.search();
        });

        if (this.getViewType() === 'inbox') {
            Cache.feedback.startPolling();
        }

        $(document).on('keydown.feedback', this.dom_handlers.documentKeydown.bind(this));
        $(document).on('click.feedback', this.dom_handlers.documentClick.bind(this));
        $(window).on('resize.feedback', this.dom_handlers.windowResize.bind(this));

        this.on('remove', () => {
            Cache.feedback.stopPolling();

            if (this.page_ready_xhr) {
                this.page_ready_xhr.abort();
            }

            clearTimeout(this.open_timeout);

            $(document).off('keydown.feedback');
            $(document).off('click.feedback');
            $(window).off('resize.feedback');
        });
    },

    initSettings() {
        var query_string = Router.getQueryString();

        this.feedback_view    = query_string.t       || Cache.app.getUserSetting('feedback_view_type', true);
        this.feedback_groupby = query_string.groupby || Cache.app.getUserSetting('feedback_groupby',   true);
        this.show_screenshot  = Cache.app.getUserSetting('show_screenshot', true) === null ? this.show_screenshot : Cache.app.getUserSetting('show_screenshot', true);

        // view type
        if (['inbox', 'list', 'grid', 'board'].indexOf(this.feedback_view) === -1) {
            this.feedback_view = 'board';
        }

        if (Cache.app.isClient() && ['list', 'grid'].indexOf(this.feedback_view) === -1) {
            this.feedback_view = 'grid';
        }

        if (this.is_design) {
            this.feedback_view = 'grid';
        } else {
            Cache.app.addUserSetting('feedback_view_type', this.feedback_view, true);
        }

        // group by
        if (['status', 'priority', 'assignee'].indexOf(this.feedback_groupby) === -1) {
            this.feedback_groupby = 'status';
        }

        if (this.getViewType() !== 'board') {
            this.feedback_groupby = '';
        }

        // order by
        var feedback_order = query_string.order || Cache.app.getUserSetting('feedback_order', true);

        if (feedback_order) {
            feedback_order = feedback_order.split(':');

            if (feedback_order.length === 2) {
                this.feedback_order_type = ['create', 'update', 'due_date'].indexOf(feedback_order[0]) === -1 ? 'create' : feedback_order[0];
                this.feedback_order      = ['desc', 'asc'].indexOf(feedback_order[1]) === -1 ? 'desc' : feedback_order[1];
            }
        }
    },

    // initilize filters from query string or user settings
    initFilters() {
        var query_string = Router.getQueryString();

        this.filters = {
            workflow       : [],
            feedback_type  : [],
            assignee       : [],
            priority       : [],
            category       : [],
            segment        : [],
            user_property  : null,
            include_merged : false,
        };

        // workflow
        var workflow_ids = query_string.workflow || Cache.app.getUserSetting('feedback_workflow', true);

        if (workflow_ids) {
            workflow_ids.split(',').forEach((workflow_id) => {
                workflow_id = parseInt(workflow_id, 10);

                if (Cache.workflow.get(workflow_id) && this.filters.workflow.indexOf(workflow_id) === -1) {
                    this.filters.workflow.push(workflow_id);
                }
            });
        }

        var feedback_include_merged = Cache.app.getUserSetting('feedback_include_merged', true);
        this.filters.include_merged = query_string.include_merged == 1 || feedback_include_merged == 1 ? true : false;

        // feedback type
        var feedback_type = query_string.type || Cache.app.getUserSetting('feedback_type', true);

        if (feedback_type) {
            feedback_type.split(',').forEach((type) => {
                if ([Constants.FEEDBACK_BUG,
                    Constants.FEEDBACK_FEATURE_REQUEST,
                    Constants.FEEDBACK_GENERAL].indexOf(parseInt(type, 10)) !== -1) {

                    this.filters.feedback_type.push(parseInt(type, 10));
                }
            });
        }

        // assignee
        var feedback_assignee = query_string.assignee || Cache.app.getUserSetting('feedback_assignee', true);

        if (feedback_assignee) {
            feedback_assignee.split(',').forEach((user_id) => {
                if (user_id == 0) {
                    this.filters.assignee.push(0); // unassigned
                } else {
                    var user = Cache.user.get(user_id);
                    var workspace_member = Cache.workspace_member.findWhere({user_id: user.id});
                    if (workspace_member && workspace_member.get('role') !== Constants.CLIENT) {
                        this.filters.assignee.push(parseInt(user_id, 10));
                    }
                }
            });
        }

        // priority
        var feedback_priority = query_string.priority || Cache.app.getUserSetting('feedback_priority', true);

        if (feedback_priority) {
            feedback_priority.split(',').forEach((priority) => {
                if (['urgent', 'high', 'neutral', 'low'].indexOf(priority) !== -1) {
                    this.filters.priority.push(priority);
                }
            });
        }

        // category
        var feedback_category = query_string.category || Cache.app.getUserSetting('feedback_category', true);
        if (feedback_category) {
            feedback_category.split(',').forEach((category) => {
                if (category == 0) {
                    this.filters.category.push(0); // unassigned
                } else {
                    if (Cache.feedback_category.findWhere({name: category})) {
                        this.filters.category.push(category);
                    }
                }
            });
        }

        // segment:
        var feedback_segment = query_string.segment || Cache.app.getUserSetting('feedback_segment', true);
        if (feedback_segment) {
            feedback_segment.split(',').forEach((segment_id) => {
                segment_id = parseInt(segment_id, 10);

                if (Cache.user_segment.get(segment_id)) {
                    this.filters.segment.push(segment_id);
                }
            });
        }

        var feedback_user_property = query_string.user_property || Cache.app.getUserSetting('feedback_user_property', true);
        if (feedback_user_property) {
            try {
                feedback_user_property = JSON.parse(feedback_user_property);

                if ([Constants.USER_SEGMENT_TYPE_AND, Constants.USER_SEGMENT_TYPE_OR].includes(feedback_user_property.segment_type) &&
                    Array.isArray(feedback_user_property.segment_condition) &&
                    feedback_user_property.segment_condition.length) {

                    this.filters.user_property = feedback_user_property;
                }
            } catch (e) {
            }
        }
    },

    createPreviewView: function(model, render) {
        if (this.is_design && model.get('load_type') !== 'upload') {
            return;
        }

        if (this.getViewType() === 'board') {
            return;
        }

        this.views.preview['_' + model.id] = new View_Feedback_Preview({
            model: model,
            view_type: () => {
                return this.getViewType();
            }
        });

        this.views.preview['_' + model.id].on('open:inbox', (feedback_model) => {
            if (Cache.account.get('is_expired')) {
                Modals.expiredAccount();
                return;
            }

            if (feedback_model.isExpired()) {
                Modals.expiredFeedback();
                return;
            }

            if (this.views.feedback_inbox instanceof View_Feedback_Inbox) {
                this.views.feedback_inbox.remove();
            }

            this.views.feedback_inbox = new View_Feedback_Inbox({
                model: feedback_model
            });
            this.views.feedback_inbox.render().$el.appendTo(this.$el.find('.region-feedback-viewer'));
        });

        if (render) {
            var view = this.views.preview['_' + model.id];
            view.render().$el.appendTo(this.$el.find('.region-feedback-preview'));
        }
    },

    createBoardView: function(workflow_model, index, priority, user_id) {
        var view_index = '_';

        if (workflow_model) {
            view_index += workflow_model.id;
        } else if (priority) {
            view_index += priority;
        } else if (user_id) {
            view_index += user_id;
        }

        this.views.boards[view_index] = new View_Feedback_Board({
            type           : this.feedback_groupby,
            workflow_id    : workflow_model ? workflow_model.id : 0,
            priority       : priority,
            user_id        : user_id,
            sort_type      : this.feedback_order_type,
            sort_order     : this.feedback_order,
            is_design      : this.is_design,
            is_open        : workflow_model && index === 0,
            is_resolved    : workflow_model && index === Cache.workflow.length - 1,
            include_merged : this.filters.include_merged,
            show_screenshot: this.show_screenshot
        });

        this.listenTo(this.views.boards[view_index], 'search_complete', this.event_handlers.onBoardViewSearchComplete);

        return this.views.boards[view_index];
    },

    renderActiveSearchOptions: function(search_options) {
        this.search_options = search_options;

        var search_count = _.size(this.search_options);
        var filters_count = 0;

        ['search', 'workflow', 'feedback_type', 'assignee', 'priority', 'category', 'segment', 'user_property', 'include_merged'].forEach((search_type) => {
            if (typeof search_options[search_type] !== 'undefined') {
                search_count--;
            }
        });

        _.each(search_options, (search_val, search_type) => {
            if (['search', 'include_merged'].indexOf(search_type) === -1) {
                filters_count++;
            }
        });

        this.$el.find('.advanced-search-toggle .count').text(search_count > 0 ? search_count : '');
        this.$el.find('.feedback-filters-clear').toggle(filters_count > 0);
    },

    renderSortDropdown: function() {
        var sort_options = '';

        sort_options +=
        (this.getViewType() === 'board' ?
        '<li class="dropdown-title">Group By</li>' +
        '<li class="group-by' + (this.feedback_groupby === 'status'   ? ' selected' : '') + '" data-val="status">Status</li>' +
        '<li class="group-by' + (this.feedback_groupby === 'priority' ? ' selected' : '') + '" data-val="priority">Priority</li>' +
        '<li class="group-by' + (this.feedback_groupby === 'assignee' ? ' selected' : '') + '" data-val="assignee">Assignee</li>' +
        '<li class="separator"></li>' :
        '');

        sort_options +=
        '<li class="dropdown-title">Sort By</li>';

        ['create', 'update', 'due_date'].forEach((option) => {
            sort_options +=
            '<li class="sort-by-type' + (this.feedback_order_type === option ? ' selected' : '') + '" data-val="' + option + '">' +
                this.getSortByString(option) +
            '</li>';
        });

        sort_options +=
        '<li class="separator"></li>' +
        (this.getViewType() !== 'board' ?
        '<li class="dropdown-title">Order</li>' : '') +
        '<li class="sort-by-order ' + (this.feedback_order === 'asc' ? '' : 'selected') + '" data-val="desc">Newest first</li>' +
        '<li class="sort-by-order ' + (this.feedback_order === 'asc' ? 'selected' : '') + '" data-val="asc">Oldest first</li>';

        sort_options +=
        (this.getViewType() === 'board' ?
        '<li class="separator"></li>' +
        '<li class="dropdown-title">View Settings</li>' +
        '<li class="show-screenshot ' + (this.show_screenshot ? 'selected' : '') + '" data-val="' + this.show_screenshot + '">Show screenshot</li>' :
        '');

        var html =
        '<div class="button-dropdown">' +
            '<button type="button" class="dropdown-select' + (this.getViewType() !== 'board' ? ' dropdown-select-small dropdown-select-text-invert' : '') + '">' +
                (this.getViewType() === 'board' ?
                'Customize':
                this.getSortByString(this.feedback_order_type)) +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-sort">' + sort_options + '</ul>' +
            '</div>' +
        '</div>';

        this.$el.find('.region-sort-dropdown').html(html);
    },

    renderTotalSelected: function() {
        this.$el.find('.feedback-count').text(Cache.feedback.length + ' of ' + Numeral(Cache.feedback.search_count).format('0,0') + ' ' + (this.is_design ? 'design files' : 'feedback'));
    },

    getWorkflowCount: function(workflow_id) {
        if (typeof Cache.feedback.workflow_count !== 'undefined' &&
            typeof Cache.feedback.workflow_count[workflow_id] !== 'undefined') {
            return Cache.feedback.workflow_count[workflow_id];
        } else {
            return 0;
        }
    },

    // remove all the existing preview view
    destroyPreviewView: function() {
        _.each(this.views.preview, function(view) {
            view.remove();
        });

        this.views.preview = {};
    },

    getViewType: function() {
        if (this.is_design) {
            return 'grid';
        } else {
            return this.feedback_view;
        }
    },

    hasSearch: function() {
        var search_options = {...this.search_options};
        delete search_options.include_merged; // ignore include_merged

        return _.size(search_options) >= 1;
    },

    loadMore: function() {
        if (this.page === this.getPageTotal()) {
            return;
        }

        this.toggleLoadMore(true, false);

        // add a delay here
        // so people can't fire multiple load requests at once
        setTimeout(() => {
            this.page++;
            this.page = Math.min(this.getPageTotal(), this.page);

            this.search(true);
        }, 500);
    },

    search: function(load_more, on_complete) {
        var query_string = Router.getQueryString();
        var form_data    = {};

        // quick search
        if (query_string.search) {
            form_data.search = query_string.search;
        }

        // default filters
        if (query_string.workflow) {
            var workflow = [];

            // validation
            query_string.workflow.split(',').forEach(function(option) {
                if (Cache.workflow.get(option)) {
                    workflow.push(parseInt(option, 10));
                }
            });

            if (workflow.length) {
                form_data.workflow = workflow;
            }
        }

        if (query_string.source) {
            var source = [];

            query_string.source.split(',').forEach(function(option) {
                if (['widget', 'portal', 'manual', 'api', 'intercom_messenger', 'csv', 'email'].indexOf(option) !== -1) {
                    source.push(option);
                }
            });

            if (source.length) {
                form_data.source = source;
            }
        }

        if (query_string.rating) {
            var rating = [];

            // validation
            query_string.rating.split(',').forEach(function(option) {
                if (['1', '2', '3', '4', '5', 'up', 'down'].indexOf(option) !== -1) {
                    rating.push(option);
                }
            });

            if (rating.length) {
                form_data.rating = rating;
            }
        }

        if (query_string.page_url) {
            form_data.page_url = query_string.page_url;
        }

        if (query_string.category) {
            form_data.category = query_string.category.split(',');
        }

        if (query_string.segment) {
            form_data.segment = query_string.segment.split(',');
        }

        if (query_string.user_property) {
            form_data.user_property = query_string.user_property;
        }

        // more filters
        if (query_string.portal_visible) {
            form_data.portal_visible = [parseInt(query_string.portal_visible, 10)];
        }

        if (query_string.empty_description) {
            form_data.empty_description = [parseInt(query_string.empty_description, 10)];
        }

        if (query_string.watch_list) {
            form_data.watch_list = [parseInt(query_string.watch_list, 10)];
        }
        // TO REMOVE: this is a temporary fix for the feedback search
        if (query_string.due_date_to) {
            // validation check due_date_to is yyyy-mm-dd
            if (query_string.due_date_to.match(/^\d{4}-\d{2}-\d{2}$/)) {
                form_data.due_date = ['', query_string.due_date_to].join('|');
            }
        }

        if (query_string.due_date) {
            if (query_string.due_date.match(/^\d{4}-\d{2}-\d{2}(\|\d{4}-\d{2}-\d{2})?$|^\|(\d{4}-\d{2}-\d{2})?$/)) {
                form_data.due_date = query_string.due_date;
            }
        }

        if (query_string.vote_count) {
            form_data.vote_count = query_string.vote_count;
        }

        if (query_string.assignee && this.feedback_groupby !== 'assignee') {
            var assignee = [];

            // validation
            query_string.assignee.split(',').forEach(function(option) {
                if (Cache.user.get(option) || option == 0) { // 0: Unassigned
                    assignee.push(parseInt(option, 10));
                }
            });

            if (assignee.length) {
                form_data.assignee = assignee;
            }
        }

        if (query_string.reporter) {
            var reporter = [];

            // validation
            query_string.reporter.split(',').forEach(function(option) {
                if (Cache.user.get(option)) {
                    reporter.push(parseInt(option, 10));
                }
            });

            if (reporter.length) {
                form_data.reporter = reporter;
            }
        }

        if (query_string.from) {
            form_data.from = query_string.from;
        }

        if (query_string.to) {
            form_data.to = query_string.to;
        }

        if (query_string.sentiment) {
            var sentiment = [];

            query_string.sentiment.split(',').forEach(function (option) {
                if (['0', '1', '2', '3'].indexOf(option) !== -1) {
                    sentiment.push(option);
                }
            })

            if (sentiment.length) {
                form_data.sentiment = sentiment;
            }
        }

        if (query_string.action_required) {
            form_data.action_required = [parseInt(query_string.action_required, 10)];
        }

        if (this.filters.workflow.length) {
            form_data.workflow = this.filters.workflow;
        }

        if (this.filters.feedback_type.length && this.filters.feedback_type.length < 3 && !this.is_design) {
            form_data.feedback_type = this.filters.feedback_type;
        }

        if (this.filters.assignee.length && !this.is_design) {
            form_data.assignee = this.filters.assignee;
        }

        if (this.filters.priority.length) {
            form_data.priority = this.filters.priority;
        }

        if (this.filters.category && this.filters.category.length) {
            form_data.category = this.filters.category;
        }

        if (this.filters.segment.length && !this.is_design) {
            form_data.segment = this.filters.segment;
        }

        if (this.filters.user_property && !this.is_design) {
            form_data.user_property = JSON.stringify(this.filters.user_property);
        }

        form_data.include_merged = this.filters.include_merged;

        if (!(this.views.feedback_search instanceof View_Feedback_Search)) {
            return;
        }

        if (_.size(form_data) || this.page > 1) {
            this.page_ready_xhr = this.views.feedback_search.doSearch(form_data, true, this.page, this.feedback_order_type, this.feedback_order, load_more, on_complete);

            if (form_data.search) {
                this.$el.find('.quick-search input').val(form_data.search);
                this.$el.find('.quick-search-clear').show();
            }

            this.renderActiveSearchOptions(form_data);
        } else {
            // TODO: remove because form data length is always greater than 0
            this.views.feedback_search.clearSearch(this.feedback_order_type, this.feedback_order);
        }
    },

    toggleEmptyState: function() {
        if (this.getViewType() === 'board') {
            return;
        }

        if (this.hasSearch()) {
            this.$el.find('.empty-adjust-search').show();
            this.$el.find('.empty-upload-designs').hide();
        } else {
            this.$el.find('.empty-adjust-search').hide();
            this.$el.find('.empty-upload-designs').show();
        }
    },

    openFeedbackFromURL: function() {
        if (this.is_design) {
            return;
        }

        var feedback_id = Router.getQueryString('feedback_id');

        if (!feedback_id) {
            return;
        }

        if (this.getViewType() === 'inbox') {
            // select in inbox list when it's found
            // otherwise open the sidebar
            if (typeof this.views.preview['_' + feedback_id] !== 'undefined') {
                this.views.preview['_' + feedback_id].$el.click();
                this.scrollToFeedback(this.views.preview['_' + feedback_id].$el);
            } else {
                Modals.openFeedbackSidebar(feedback_id);
            }
        } else {
            // open sidebar
            Modals.openFeedbackSidebar(feedback_id);
        }
    },

    onPageReady: function() {
        this.search(false, this.openFeedbackFromURL.bind(this));

        var view_type = this.getViewType();

        if (view_type === 'board') {
            // scroll event does not bubble up in backbone events
            this.$el.find('.feedback-board-container > div').on('scroll.board', this.dom_handlers.onBoardScroll.bind(this));
            this.$el.find('.feedback-board-container > div').trigger('scroll');

            $(window).trigger('resize.feedback');
        } else {
            var scroll_container = this.getScrollContainer();

            // backbone does not handle scroll events in the "events" hash
            // so we need to bind the event manually
            scroll_container.on('scroll', this.dom_handlers.onScrollFeedback.bind(this));
        }

        var show_onboarding = Router.getQueryString('onboarding') === '1' && !Cache.get('show_onboarding_welcome');

        if (show_onboarding) {
            Modals.showOnboardingWelcome(() => {
                Cache.add('show_onboarding_welcome', true, false);
                Router.removeQueryString('onboarding', {trigger: false, replace: true});

                Cache.app.dispatcher.trigger('onboarding_welcome_close');
            });
        }
    },

    getSortByString: function(feedback_order_type) {
        switch (feedback_order_type) {
            case 'create':
                return 'Date created';
            case 'update':
                return 'Date updated';
            case 'due_date':
                return 'Due date';
        }
    },

    render: function() {
        if (this.is_design) {
            UI.setPageTitle('Designs');
        } else {
            UI.setPageTitle('Feedback');
        }

        var view_type = this.getViewType();

        var content =
        '<div class="fullscroll-action-bar feedback-action-bar">' +
            '<div>' +
                // search + filters + view toggle
                '<div class="region-search">' +
                    '<div class="search">' +
                        '<form class="quick-search">' +
                            '<input type="text" placeholder="' + (this.is_design ? 'Search designs' : 'Search feedback') + '" maxlength="100">' +
                            '<button type="button" class="quick-search-clear"><i class="fas fa-times-circle info"></i></button>' +
                        '</form>' +
                    '</div>' +
                    '<div class="flex-between">' +
                        '<div class="region-feedback-filter-scroller">' +
                            '<div class="region-feedback-filters"></div>' +
                            (this.is_design ? '' :
                            '<div class="region-feedback-filters-advanced">' +
                                '<button type="button" class="dropdown-select dropdown-select-text advanced-search-toggle">' +
                                    '<span class="label">More</span>' +
                                    '<span class="count"></span>' +
                                '</button>' +
                                '<div class="advanced-search-filters"></div>' +
                            '</div>') +
                            '<button type="button" class="feedback-filters-clear small text-link tooltip" data-title="Clear filters" data-offset="0,10">Clear</button>' +
                        '</div>' +
                        (this.is_design ?
                        '<button class="primary small min inline upload-design"><i class="far fa-plus margin-right-8"></i>Upload</button>' :
                        '<div class="view-selector">' +
                            '<div class="button-dropdown">' +
                                '<button type="button" class="dropdown-select dropdown-select-text font-weight-medium">' +
                                    (this.getViewType() === 'inbox' ? '<span class="icon"><i class="fa-regular fa-table-layout"></i></span><span class="text">Inbox View</span>' : '') +
                                    (this.getViewType() === 'list'  ? '<span class="icon"><i class="fa-regular fa-list"></i></span><span class="text">List View</span>'  : '') +
                                    (this.getViewType() === 'grid'  ? '<span class="icon"><i class="fa-regular fa-grid"></i></span><span class="text">Grid View</span>'  : '') +
                                    (this.getViewType() === 'board' ? '<span class="icon"><i class="fa-regular fa-columns-3"></i></span><span class="text">Board View</span>' : '') +
                                '</button>' +
                                '<div>' +
                                    '<ul class="dropdown dropdown-select dropdown-view-type">' +
                                        (Cache.app.isClient() ? '' :
                                        '<li data-val="board"' + (this.getViewType() === 'board'  ? ' class="selected"' : '') + '>Board View</li>') +
                                        (Cache.app.isClient() ? '' :
                                        '<li data-val="inbox"'  + (this.getViewType() === 'inbox' ? ' class="selected"' : '') + '>Inbox View</li>') +
                                        '<li data-val="list"'   + (this.getViewType() === 'list'  ? ' class="selected"' : '') + '>List View</li>' +
                                        '<li data-val="grid"'   + (this.getViewType() === 'grid'  ? ' class="selected"' : '') + '>Grid View</li>' +
                                    '</ul>' +
                                '</div>' +
                            '</div>' +
                        '</div>') +
                    '</div>' +
                '</div>' +
                // group actions
                (Cache.app.isClient() ? '' :
                '<div class="region-group-action">' +
                    '<div class="item-counter"><span class="num"></span> selected<a href="#" class="clear-selection tooltip" data-title="Clear"><i class="fas fa-times-circle info"></i></a></div>' +
                '</div>') +
            '</div>' +
        '</div>';

        content += '<div class="fullscroll-body">';

        if (this.is_design) {
            content += '<div class="feedback-upload-dropdown dropdown-box">' +
                            '<div class="overflow-hidden">' +
                                '<div class="feedback-upload-video">' +
                                    '<i class="fad fa-fw fa-film-alt"></i>' +
                                    '<div class="title">Upload Video</div>' +
                                    '<div class="desc">mp4 or mov videos</div>' +
                                '</div>' +
                                '<div class="feedback-upload-design">' +
                                    '<i class="fad fa-fw fa-images"></i>' +
                                    '<div class="title">Upload Design</div>' +
                                    '<div class="desc">png, jpg or gif images</div>' +
                                '</div>' +
                                '<div class="feedback-upload-pdf">' +
                                    '<i class="fad fa-fw fa-file-pdf"></i>' +
                                    '<div class="title">Upload PDF</div>' +
                                    '<div class="desc">pdf documents</div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="feedback-scrape">' +
                                '<div>or, <a href="#">Create design from a website</a></div>' +
                            '</div>' +
                        '</div>';
        }

        if (view_type === 'board') {
            content += '<div class="feedback-board-name flex-between">' +
                            '<h2>' + Util.cap(this.feedback_groupby) + ' Board</h2>' +
                            '<div class="region-sort-dropdown"></div>' +
                        '</div>';
            content += '<div class="feedback-board-container' + (Cache.app.isClient() ? ' client-view' : '') + '" data-sort="' + this.feedback_order_type + '">' +
                            '<div></div>' +
                        '</div>';
        } else {
            content += '<div class="feedback-preview-container' + (Cache.app.isClient() ? ' client-view' : '') + '" data-sort="' + this.feedback_order_type + '" viewtype="' + this.getViewType() + '">' +

                            '<div class="region-feedback-list">' +
                                (this.getViewType() === 'board' ? '' :
                                '<div class="region-pagination">' +
                                    '<div class="select-all">' +
                                        (Cache.app.isClient() ? '' :
                                        '<input type="checkbox" id="feedback_select_all">' +
                                        '<label for="feedback_select_all"><span class="text-info feedback-count"></span></label>') +
                                    '</div>' +

                                    '<div class="region-sort-dropdown"></div>' +
                                '</div>') +
                                '<div class="region-feedback-preview"></div>' +
                            '</div>' +

                            '<div class="region-feedback-viewer"></div>' +
                                '<div class="feedback-no-result search-result-empty">' +
                                    '<p class="text-regular">No ' + (this.is_design ? 'designs' : 'feedback') + ' found</p>' +
                                    '<div class="empty-adjust-search">' +
                                        '<p class="text-info">Try adjusting your search to find what you\'re looking for.</p>' +
                                        '<p><a href="#" class="clear-search primary">Clear search</a></p>' +
                                    '</div>' +
                                    '<div class="empty-upload-designs">' +
                                        (this.is_design ?
                                        '<p class="text-info">To get started, simply upload your <a class="file-type-design primary" href="#">images</a>, <a class="file-type-video primary underline" href="#">videos</a> or <a class="file-type-pdf primary underline" href="#">PDF files</a>.</p>' :
                                        '<p class="text-info text-default line-height-150">To get started, simply <a class="primary install-widget" href="#"><i class="fa-solid fa-square-code"></i> install widget</a> to collect feedback from your site, or submit a feedback from the <a href="#" class="feedback-demo primary">demo page <i class="fa-solid fa-square-arrow-up-right"></i></a>.</p>') +
                                        (view_type === 'inbox' ? '' :
                                        '<div class="video-explainer margin-top-24">' +
                                            '<video width="640" height="360"><source src="https://static.userback.io/video/empty_state_feedback.mp4" type="video/mp4" /></video>' +
                                        '</div>') +
                                    '</div>' +
                                '</div>' +
                        '</div>';
        }

        if (view_type === 'board') {
            content += '<div class="kanban-column-indicator">';
            content +=     '<div class="scroller"><span class="kanban-indicator-widget"></span></div>';

            _.each(this.views.boards, () => {
                content += '<div class="column"></div>';
            });

            content += '</div>';
        }

        content += '</div>';

        this.$el.html(content);

        this.renderSortDropdown();

        this.views.feedback_search.render().$el.appendTo(this.$el.find('.advanced-search-filters'));
        this.views.feedback_filter.render().$el.appendTo(this.$el.find('.region-feedback-filters'));
        this.views.feedback_group_action.render().$el.appendTo(this.$el.find('.region-group-action'));

        if (view_type === 'board') {
            _.each(this.views.boards, (view) => {
                view.render().$el.appendTo(this.$el.find('.feedback-board-container > div'));
            });

            this.$el.addClass('topless bottomless');
        }

        return this;
    }
});